<script>
import StatusBar from '@/V2/components/status/StatusBar.vue';
import StatusBadge from '@/V2/components/status/StatusBadge.vue';
import { SALARY_CROSS_CHECK_PROPERTIES } from '@/constants/signals/customer-signals.constants';
import {
  iButton,
  iButtonTypes,
  iButtonStyles,
  iButtonSizes,
  iFeaturedIcon,
  iFeaturedIconSizes,
} from '@inscribe/signal';

export default {
  components: { StatusBar, StatusBadge, iButton, iFeaturedIcon },
  props: {
    signal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      SALARY_CROSS_CHECK_PROPERTIES,
      iButtonTypes,
      iButtonStyles,
      iButtonSizes,
      iFeaturedIconSizes,
    };
  },
  methods: {
    viewPayslip(item) {
      this.$router.push({
        name: 'document-parsed-details-highlighter',
        params: {
          customer_id: this.$route.params.customer_id,
          document_id: item.payslip_data?.document_id,
        },
        query: {
          bounding_box_ids: item.payslip_data?.bounding_box_ids,
        },
      });
    },
    viewTransaction(item) {
      this.$router.push({
        name: 'document-parsed-details-highlighter',
        params: {
          customer_id: this.$route.params.customer_id,
          document_id: item.salary_transaction?.document_id,
        },
        query: {
          bounding_box_ids: item.salary_transaction?.bounding_box_ids,
        },
      });
    },
  },
};
</script>

<template>
  <div
    class="customer-fraud-cross-check-details d-flex flex-column align-items-start i-gap-9"
  >
    <status-bar :state="signal.status" :label="signal.badgeLabel" />
    <div class="i-text-body-2">
      {{ signal.description }}
    </div>

    <div
      v-for="item in signal.value.salary_cross_check_items"
      :key="item.id"
      class="item d-flex flex-column i-radius-xl"
    >
      <!-- header -->
      <div class="header d-flex flex-row i-p-8 i-gap-6">
        <i-featured-icon
          :size="iFeaturedIconSizes.SM"
          symbol="medium-money-coins"
          type="neutral"
        ></i-featured-icon>
        <div class="text d-flex flex-column i-text-body-2 i-gap-2">
          <div class="data d-flex flex-row i-text-body-2 i-gap-6">
            <div class="description i-text-subheading-3">
              {{ item.salary_transaction.tx_description }}
            </div>
            <div class="amount i-text-subheading-3">
              ${{ item.salary_transaction.tx_amount }}
            </div>
          </div>
          <div class="i-text-body-3">
            {{ item.salary_transaction?.tx_date }}
          </div>
        </div>
      </div>

      <!-- body -->
      <div class="body d-flex flex-column i-text-body-2 i-gap-6 i-p-8">
        <div class="i-text-body-3">
          {{ item.rationale }}
        </div>
        <status-badge
          :label="SALARY_CROSS_CHECK_PROPERTIES[item.outcome].label"
          :state="SALARY_CROSS_CHECK_PROPERTIES[item.outcome].status"
        />
      </div>

      <!-- footer -->
      <div class="footer d-flex flex-row i-p-8 i-gap-4">
        <i-button
          label="View Transaction"
          :type="iButtonTypes.NEUTRAL"
          :disabled="!item.salary_transaction"
          :button-style="iButtonStyles.OUTLINE"
          :size="iButtonSizes.SMALL"
          @button-click="viewTransaction(item)"
        />

        <i-button
          label="View Payslip"
          :type="iButtonTypes.NEUTRAL"
          :button-style="iButtonStyles.OUTLINE"
          :size="iButtonSizes.SMALL"
          :disabled="!item.payslip_data"
          @button-click="viewPayslip(item)"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.customer-fraud-cross-check-details {
  .item {
    border: 1px solid $light-neutral-60;

    .description {
      color: $light-neutral-120;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 360px;
    }
  }

  .header,
  .body {
    border-bottom: 1px solid $light-neutral-60;
  }

  .footer {
    .i-button {
      width: 100%;
    }
  }
}
</style>
